module.exports = __webpack_public_path__ + "img/box1_price_img.3dc58361.png";